module.exports = __webpack_public_path__ + "static/img/icon-4.d14f773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/icon-4.png
// module id = yhNd
// module chunks = 0